import React, { Component, Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import classes from './Message.module.scss';
import moment from 'moment-timezone'
import DoneIcon from '@mui/icons-material/Done';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import styled from 'styled-components';
import _, { findLastIndex } from 'lodash';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DownloadIcon from '@mui/icons-material/Download';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { boxiGreen, boxiPrimary, boxiRed } from "../../../../assets/style/colors";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Tooltip, Button, makeStyles, Card, CardActionArea, CardHeader, Avatar, CardContent, CardActions, IconButton, Typography, } from "@mui/material";
import axios from "axios";
import { Spinner, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import SaveIcon from '@mui/icons-material/Save';
import { toast } from 'react-toastify';
import Chip from '@mui/material/Chip';
import EditIcon from '@mui/icons-material/Edit';
import { DuplicateImageFile } from "./DuplicateImageFile";


const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
`;

const Image = styled.img`
  object-fit: cover;
  cursor: pointer;
  ${props => props.width === 'auto' ? 'width: 100vw' : 'width: 100%'};
  ${props => props.height === '100%' ? 'height: 100%;' : props.height === '100vh' ? 'height: 100vh; object-fit: contain;' : 'height: auto'};
`;

const MoreImages = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.5);
  color: white;
  font-size: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const DuplicateFound = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(240, 69, 58,0.5);
  color: white;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const FullScreenModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Arrow = styled.div`
  color: white;
  font-size: 2rem;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.direction === 'left' ? 'left: 15px' : 'right: 15px'}
`;

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};


const Message = ({ message, isCurrentChatPictureBlast, vendor_id }) => {

  const [showSentBy, setShowSentBy] = useState(false);

  const [fullScreen, setFullScreen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [images, setImages] = useState([]);
  const [isImageDownloading, setIsImageDownloading] = useState(false);
  const [showTagInput, setShowTagInput] = useState(false);
  const [truckList, setTruckList] = useState([{ title: '', value: 0, truck_name: '' }]);
  const [originalTruckList, setOriginalTruckList] = useState([{ title: '', value: 0, truck_name: '' }]);
  const [selectedValue, setSelectedValue] = useState({ title: '', value: 0, truck_name: '' })
  const [isTaggingDisable, setIsTaggingDisable] = useState(true);
  const [isTagLoading, setIsTagLoading] = useState(true);
  const [alreadyTaggedTruck, setAlreadyTaggedTruck] = useState('')
  const [saveTagLoading, setSaveTagLoading] = useState(false)
  const [alreadyTaggedTruckData, setAlreadyTaggedTruckData] = useState(null)
  const [editTag, setEditTag] = useState(false)
  const [loadingCampaigns, setLoadingCampaigns] = useState(false)
  const [searchVendor, setSearchVendor] = useState('')
  const [isVendorSearchLoading, setIsVendorSearchLoading] = useState(false)
  const [vendors, setVendors] = useState([])
  const [selectedVendorId, setSelectedVendorId] = useState(null)
  const [selectedVendor, setSelectedVendor] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'ArrowLeft') {
        // Move to the previous image
        if (fullScreen) previousImage();
      } else if (event.key === 'ArrowRight') {
        // Move to the next image
        if (fullScreen) nextImage();
      } else if (event.key === 'Escape') {
        if (fullScreen) closeFullScreen();
      }
    };

    if (fullScreen) document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      setAlreadyTaggedTruck('');
      setAlreadyTaggedTruckData(null)
      setIsTaggingDisable(true);
      setEditTag(false)
      setSearchVendor('');
      setIsVendorSearchLoading(false);
      setVendors([]);
      setSelectedVendorId(null);
      setSelectedVendor(null);

    };
  }, [fullScreen, currentImage]);

  const getAlreadyTagImage = async (url) => {
    let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/get-pictures-tagging-by-url?url=${typeof url === 'string' ? url : url.url}`);
    if (Object.keys(res.data.tag).length !== 0) {
      if (res.data.tag.length > 0 && res.data.tag[0].truck_name) {
        setIsTaggingDisable(true)
        setIsTagLoading(false)
        setAlreadyTaggedTruck(`@ ${res.data.tag[0].truck_name} ${res.data.tag[0].license_plate}`)
        const data = res.data.tag[0]
        setAlreadyTaggedTruckData({...data, title: `Truck Name: ${data.truck_name}, License Plate: ${data.license_plate}, Campaign: ${data.campaign_name}`})
        setEditTag(false)
      }
    } else {
      setIsTaggingDisable(false)
      setIsTagLoading(false)
      setEditTag(false)
      setAlreadyTaggedTruck(``)
      setAlreadyTaggedTruckData(null)
    }

  }

  const openFullScreen = (index) => {
    setFullScreen(true);
    if (isCurrentChatPictureBlast) {
      getAlreadyTagImage(images[index]);
      getAllCampaignTrucks();
    }
    setShowTagInput(false);
    setEditTag(false)
    setCurrentImage(index);
    setSearchVendor('');
    setIsVendorSearchLoading(false);
    setVendors([]);
    setSelectedVendorId(null);
    setSelectedVendor(null);
  };

  const closeFullScreen = () => {
    setFullScreen(false);
    setIsTagLoading(true);
    setEditTag(false)
    setShowTagInput(false);
    setIsTaggingDisable(true);
    setCurrentImage(0);
    setSearchVendor('');
    setIsVendorSearchLoading(false);
    setVendors([]);
    setSelectedVendorId(null);
    setSelectedVendor(null);
  };

  const nextImage = () => {
    if (isCurrentChatPictureBlast) {
      getAlreadyTagImage(images[(currentImage + 1) % images.length]);
    }
    setShowTagInput(false);
    setEditTag(false)
    setIsTagLoading(true)
    setCurrentImage((currentImage + 1) % images.length);
    setSearchVendor('');
    setIsVendorSearchLoading(false);
    setVendors([]);
    setSelectedVendorId(null);
    setSelectedVendor(null);
  };

  const previousImage = () => {
    if (isCurrentChatPictureBlast) {
      getAlreadyTagImage(images[(currentImage - 1 + images.length) % images.length]);
    }
    setShowTagInput(false);
    setEditTag(false)
    setIsTagLoading(true)
    setCurrentImage((currentImage - 1 + images.length) % images.length);
    setSearchVendor('');
    setIsVendorSearchLoading(false);
    setVendors([]);
    setSelectedVendorId(null);
    setSelectedVendor(null);
  };

  const isValidJSON = str => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    if (isValidJSON(message.media)) {
      setImages(JSON.parse(message.media))
    }
  }, [])

  useEffect(() => {
    const handleKeyPress = (event) => {
      const { key } = event;
      if (fullScreen) {
        if (key === 'ArrowLeft') {
          // Left arrow key pressed
          console.log('Left arrow key pressed');
          // Add your logic for the left arrow key press
        } else if (key === 'ArrowRight') {
          // Right arrow key pressed
          console.log('Right arrow key pressed');
          // Add your logic for the right arrow key press
        }
      }
    };

    // Add the event listener when the component mounts
    document.addEventListener('keydown', handleKeyPress);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      setShowTagInput(false)
    };
  }, []);

  const handleChipClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDownload = (url) => {
    setIsImageDownloading(true)
    axios
      .get(`${process.env.REACT_APP_API_HOST}/communication/download-media/${encodeURIComponent(url)}`, {
        responseType: 'blob'
      })
      .then((response) => {
        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'downloaded-media';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setIsImageDownloading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setIsImageDownloading(false);
      });
  }
  const getAllCampaignTrucks = async (vendor = null) => {
    setLoadingCampaigns(true)
    if (vendor === null && vendor_id !== -1) {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/campaign-trucks?vendor_id=${vendor_id}`);
      if (res?.data?.campaignTrucks?.length > 0) {
        let options = res.data.campaignTrucks.map((item) => ({
          ...item,
          title: `Truck Name: ${item.truck_name}, License Plate: ${item.license_plate}, Campaign: ${item.campaign_display_name}`,
          value: item.truck_id
        }))
        setLoadingCampaigns(false)
        setTruckList([...options])
        setOriginalTruckList([...options])
      } else {
        setLoadingCampaigns(false)
        setTruckList([])
        setOriginalTruckList([])
      }
    } else {
      setSelectedVendorId(vendor)
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/campaign-trucks?vendor_id=${vendor}`);
      if (res?.data?.campaignTrucks?.length > 0) {
        let options = res.data.campaignTrucks.map((item) => ({
          ...item,
          title: `Truck Name: ${item.truck_name}, License Plate: ${item.license_plate}, Campaign: ${item.campaign_display_name}`,
          value: item.truck_id
        }))
        setLoadingCampaigns(false)
        setTruckList([...options])
        setOriginalTruckList([...options])
      } else {
        setLoadingCampaigns(false)
        setTruckList([])
        setOriginalTruckList([])
      }
    }
  };

  const debouncedHandler = value => {
    const filtered = value !== ''
      // ? truckList.filter((item) => item?.title.toLowerCase().includes(value.toLowerCase()))
      ? originalTruckList.filter((item) => 
        item?.truck_name.toLowerCase().includes(value.toLowerCase()) ||
        item?.license_plate.toLowerCase().includes(value.toLowerCase()) ||
        item?.campaign_display_name.toLowerCase().includes(value.toLowerCase())
      )
      : originalTruckList;

    setTruckList(filtered);
  }

  const searchVendors = async () => {
    if (searchVendor.length > 0) {
      try {
        setIsVendorSearchLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/search-vendor/${searchVendor}`);
        setVendors(res.data.vendors)
        setIsVendorSearchLoading(false);
      } catch (error) {
        setIsVendorSearchLoading(false);
        console.error(error)
      }
    } else {
      setVendors([])
    }
  }

  const onSearchVendorClickHandler = (vendor) => {
    getAllCampaignTrucks(vendor.vendor_id)
    setSelectedVendor(vendor)
  }

  const saveTagHandler = async (value) => {
    setSaveTagLoading(true)
    if (selectedValue) {
      let data = {
        truck_id: selectedValue.value,
        image_url: value,
        vendor_id: vendor_id === -1 ? selectedVendorId : vendor_id,
        campaign_name: selectedValue?.campaign_display_name?.length > 0 ? selectedValue?.campaign_display_name : null,
        tagged_by: parseInt(localStorage.getItem('userId')) ? localStorage.getItem('userId') : null
      }
      let res = await axios.post(`${process.env.REACT_APP_API_HOST}/comunication/picture-tagging`, data, config);
      if (res.status === 200) {
        setShowTagInput(false)
        setSaveTagLoading(false)
        setSearchVendor('');
        setIsVendorSearchLoading(false);
        setVendors([]);
        if (vendor_id === -1) {
          setTruckList([]);
          setOriginalTruckList([]);
        }
        setSelectedVendorId(null);
        setSelectedVendor(null);
        toast.success('Tag added Successfully')
        setSelectedValue({ title: '', value: 0, truck_name: '' })
        await getAlreadyTagImage(value)
      } else {
        setShowTagInput(false)
        setSaveTagLoading(false)
        setSearchVendor('');
        setIsVendorSearchLoading(false);
        setVendors([]);
        if (vendor_id === -1) {
          setTruckList([]);
          setOriginalTruckList([]);
        }
        setSelectedVendorId(null);
        setSelectedVendor(null);
        setSelectedValue({ title: '', value: 0, truck_name: '' })
        await getAlreadyTagImage(value)
      }
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: message.direction == 'outbound' ? 'row-reverse' : 'row', alignItems: 'flex-end', columnGap: 5 }}>
      <div onMouseEnter={() => setShowSentBy(true)} onMouseLeave={() => setShowSentBy(false)} className={`my-1 ${classes.message} ${message.direction == 'outbound' ? message.message_status == 'scheduled' ? classes.scheduled : classes.sender : classes.receiver}`} style={{ fontSize: '13px' }}>
        <div style={{ marginBottom: 10 }}>
          {message.media && message.media !== "null" &&
            (
              isValidJSON(message.media) &&
                images.length > 1 ?
                <Grid>
                  {images.slice(0, 4).map((image, index) => (
                    <ImageWrapper key={index}>
                      <Image height="100%" src={typeof image === 'string' ? image : image.url} alt="message" onClick={() => openFullScreen(index)} />
                      {typeof image !== 'string' && image.is_duplicate && <DuplicateFound onClick={() => openFullScreen(index)}>Duplicate Found</DuplicateFound>}
                      {images.length > 4 && index === 3 && <MoreImages>+{images.length - 4} more</MoreImages>}
                    </ImageWrapper>
                  ))}
                  {fullScreen &&
                    <FullScreenModal>
                      <HighlightOffIcon onClick={closeFullScreen} style={{ position: 'absolute', top: 15, right: 15, cursor: 'pointer', color: 'white' }} />
                      {isImageDownloading ?
                          <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: 'white' }}></Spinner>
                          :
                          <div style={{color: 'white' }}>
                            <DownloadIcon onClick={() => handleDownload(images[currentImage])} style={{ position: 'absolute', top: 16, right: 50, cursor: 'pointer' }} />
                            {message?.direction === 'inbound' && isCurrentChatPictureBlast && !isTaggingDisable && <LocalOfferIcon onClick={() => setShowTagInput(true)} style={{ position: 'absolute', top: 16, right: 80, cursor: 'pointer' }} />}
                            {isTagLoading && isCurrentChatPictureBlast && (<Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 80, cursor: 'not-allowed', color: 'white' }}></Spinner>)}
                            {typeof images[currentImage] !== 'string' && images[currentImage].is_duplicate && <div>
                              <Chip label="Duplicate Found" style={{backgroundColor: '#b51c1c', color: 'white' ,display: 'flex', position: 'absolute', top: 15, right: 120, cursor: 'pointer'}} onClick={handleChipClick} />
                              {isModalOpen && <DuplicateImageFile isOpen={isModalOpen} onClose={closeModal} img={images[currentImage]} />}
                            </div>}
                          </div>

                        }
                      <Arrow direction="left" onClick={previousImage}>←</Arrow>
                      <Image height="100vh" width="auto" src={typeof images[currentImage] === 'string' ? images[currentImage] : images[currentImage].url} alt="message" />
                      {isCurrentChatPictureBlast && isTaggingDisable && alreadyTaggedTruckData !== null && (
                        <Card
                          style={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            backgroundColor: boxiPrimary,
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: '#fff',
                            alignItems: 'baseline',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            let selected = truckList.find(item => item.truck_id === alreadyTaggedTruckData.truck_id && alreadyTaggedTruckData.license_plate === item.license_plate)
                            setShowTagInput(true)
                            setEditTag(true)
                            setSelectedValue(selected)
                            if (vendor_id === -1) {
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                            }
                          }}
                        >
                          <CardContent style={{ fontSize: '10px', fontFamily: 'Poppins' }}>

                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                              <span style={{ color: '#D3D3D3' }}>
                                <div style={{ fontWeight: 300 }}>Tagged By: </div>
                              </span>
                              <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.user_name}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                              <span style={{ color: '#D3D3D3' }}>
                                <div style={{ fontWeight: 300 }}>Truck Name: </div>
                              </span>
                              <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.truck_name}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                              <span style={{ color: '#D3D3D3', fontWeight: 300 }}>
                                <div style={{ fontWeight: 300 }}>License Plate: </div>
                              </span>
                              <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.license_plate}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                              <span style={{ color: '#D3D3D3' }}>
                                <div style={{ fontWeight: 300 }}>Campaign Name: </div>
                              </span>
                              <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.campaign_name}</span>
                            </div>
                          </CardContent>
                        </Card>
                      )}
                      {vendor_id !== -1 && showTagInput && truckList?.length > 0 && (
                        <Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                          Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>

                            <Autocomplete
                              onChange={(e, newValue) => {
                                setSelectedValue(newValue);
                              }}
                              id="merchant-autocomplete"
                              disableClearable
                              value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                              options={truckList}
                              getOptionLabel={(option) => option.title}
                              renderOption={(props, option) => {
                                return (
                                  <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                  >
                                    <CardActionArea>
                                      <CardHeader
                                        title={<div className={'text-truncate'} style={{
                                          maxWidth: 230, fontFamily: 'Poppins',
                                          fontSize: '12px'
                                        }}>
                                          {option.truck_name}
                                        </div>
                                        }
                                        subheader={<div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'start',
                                          fontFamily: 'Poppins',
                                          fontSize: '10px'

                                        }}>
                                          <div>
                                            {option.license_plate}
                                          </div>
                                          <div>
                                            {option.campaign_display_name}
                                          </div>
                                        </div>}
                                        action={
                                          <PaidRoundedIcon
                                            style={{
                                              color: boxiPrimary,
                                            }}
                                          />
                                        }
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              }}
                              renderInput={(params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <TextField
                                    {...params}
                                    label="Tag Image to truck"
                                    variant="standard"
                                    // onChange={(e) => debouncedHandler(e.target.value)}
                                  />
                                  {selectedValue?.title !== '' && !saveTagLoading ? (
                                    <SaveIcon
                                      color="primary"
                                      onClick={() => saveTagHandler(images[currentImage])}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  ) : selectedValue?.title !== '' && saveTagLoading ? (
                                    <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                  ) : (
                                    <SaveIcon
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}
                                </div>
                              )}
                            />
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>)}
                      {vendor_id === -1 && selectedVendorId && showTagInput && truckList?.length > 0 && (<Modal isOpen={true} className='composeModal'>
                        <ModalHeader>
                        Select Truck To Tag
                        </ModalHeader>
                        <ModalBody>
                          <Autocomplete
                            onChange={(e, newValue) => {
                              setSelectedValue(newValue);
                            }}
                            id="merchant-autocomplete"
                            disableClearable
                            value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                            options={truckList}
                            getOptionLabel={(option) => option.title}
                            renderOption={(props, option) => {
                              return (
                                <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                >
                                  <CardActionArea>
                                    <CardHeader
                                      title={<div className={'text-truncate'} style={{
                                        maxWidth: 230, fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        {option.truck_name}
                                      </div>
                                      }
                                      subheader={<div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'start',
                                        fontFamily: 'Poppins',
                                        fontSize: '10px'

                                      }}>
                                        <div>
                                          {option.license_plate}
                                        </div>
                                        <div>
                                          {option.campaign_display_name}
                                        </div>
                                      </div>}
                                      action={
                                        <PaidRoundedIcon
                                          style={{
                                            color: boxiPrimary,
                                          }}
                                        />
                                      }
                                    />
                                  </CardActionArea>
                                </Card>
                              );
                            }}
                            renderInput={(params) => (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <TextField
                                  {...params}
                                  label="Tag Image to truck"
                                  variant="standard"
                                  onChange={(e) => debouncedHandler(e.target.value)}
                                />
                                {selectedValue?.title !== '' && !saveTagLoading ? (
                                  <SaveIcon
                                    color="primary"
                                    onClick={() => saveTagHandler(images[currentImage])}
                                    style={{ cursor: 'pointer' }}
                                  />
                                ) : selectedValue?.title !== '' && saveTagLoading ? (
                                  <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                ) : (
                                  <SaveIcon
                                    style={{ cursor: 'pointer' }}
                                  />
                                )}
                              </div>
                            )}
                          />
                        </ModalBody>
                        <ModalFooter>
                          <Button color="secondary" onClick={() => {
                            setShowTagInput(false)
                            setSearchVendor('');
                            setIsVendorSearchLoading(false);
                            setVendors([]);
                            setSelectedVendorId(null);
                            setSelectedVendor(null);
                            if (vendor_id === -1) {
                              setTruckList([])
                              setOriginalTruckList([]);
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                            }
                            setSelectedValue({ title: '', value: 0, truck_name: '' })

                          }}>
                            Close
                          </Button>
                        </ModalFooter>
                      </Modal>)}
                      {showTagInput && (truckList.length === 0) && vendor_id !== -1 && !loadingCampaigns && (
                        <Modal isOpen={true} className='composeModal'>

                          <ModalHeader>
                          Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <div style={{ margin: '20px' }}>
                              No Truck Found to Tag
                            </div>
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>

                        </Modal>

                      )}
                      {showTagInput && (truckList.length === 0) && vendor_id === -1 && selectedVendorId && !loadingCampaigns && (
                        <Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                            Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <div style={{ margin: '20px' }}>
                              No Truck Found to Tag
                            </div>
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>

                      )}
                      {showTagInput && vendor_id === -1 && truckList.length === 0 && !selectedVendorId && (
                        <Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                          Search Vendor
                          </ModalHeader>
                          <ModalBody>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', columnGap: 10 }}>
                              <TextField
                                id="standard-search"
                                label="Search Vendor"

                                variant="outlined"
                                style={{
                                  borderRadius: '10px'
                                }}
                                value={searchVendor}
                                onChange={(e) => setSearchVendor(e.target.value)}
                              />
                              <Button style={{
                                borderRadius: '10px',
                                border: '1px solid' + boxiPrimary
                              }} disabled={isVendorSearchLoading} color="primary" onClick={searchVendors}>Search</Button>
                            </div>
                            {vendors.length > 0 && <div className={classes.searchVendorList}>
                              {vendors.map((vendor, index) => {
                                return (
                                  <div className={classes.searchVendor} style={{ cursor: 'pointer', filter: `'contrast(1)` }} onClick={() => {
                                    onSearchVendorClickHandler(vendor)
                                  }}>
                                    <div className={classes.vendorName}>{vendor.name}</div>
                                    <div className={classes.vendorPhone}>{vendor.phone_num}</div>
                                  </div>
                                )
                              })}
                            </div>}
                            {isVendorSearchLoading && vendors.length === 0 && (
                              <div style={{ margin: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Spinner style={{ color: boxiPrimary, margin: '0px 10px' }}></Spinner>
                                <div>Loading Vendors...</div>
                              </div>
                            )}
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>
                      )}
                      <Arrow direction="right" onClick={nextImage}>→</Arrow>
                    </FullScreenModal>
                  }
                </Grid>
                :
                images.length == 1
                  ?
                  <>
                    <div style={{ position: 'relative' }}>
                      <Image height="100%" src={typeof images[0] === 'string' ? images[0] : images[0].url} alt="message" onClick={() => openFullScreen(0)} />
                      {typeof images[0] !== 'string' && images[0].is_duplicate && <DuplicateFound onClick={() => openFullScreen(0)}>Duplicate Found</DuplicateFound>}
                    </div>
                    {fullScreen &&
                      <FullScreenModal>
                        <HighlightOffIcon onClick={closeFullScreen} style={{ position: 'absolute', top: 15, right: 15, cursor: 'pointer', color: 'white' }} />
                        <div style={{ color: 'white' }}>
                          {isImageDownloading ?
                            <Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: 'white' }}></Spinner>
                            :
                            <>
                              <DownloadIcon onClick={() => handleDownload(typeof images[0] === 'string' ? images[0] : images[0].url)} style={{ position: 'absolute', top: 16, right: 50, cursor: 'pointer' }} />
                              {message?.direction === 'inbound' && isCurrentChatPictureBlast && !isTaggingDisable && <LocalOfferIcon onClick={() => setShowTagInput(true)} style={{ position: 'absolute', top: 16, right: 80, cursor: 'pointer' }} />}
                              {isTagLoading && isCurrentChatPictureBlast && (<Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 80, cursor: 'not-allowed', color: 'white' }}></Spinner>)}
                              {typeof images[0] !== 'string' && images[0].is_duplicate && <div>
                                <Chip label="Duplicate Found" style={{backgroundColor: '#b51c1c', color: 'white' ,display: 'flex', position: 'absolute', top: 15, right: 120, cursor: 'pointer'}} onClick={handleChipClick} />
                                {isModalOpen && <DuplicateImageFile isOpen={isModalOpen} onClose={closeModal} img={images[0]} />}
                              </div>}
                            </>

                          }
                        </div>
                        <Image height="100vh" width="auto" src={typeof images[0] === 'string' ? images[0] : images[0].url} alt="message" />
                        {isCurrentChatPictureBlast && isTaggingDisable && alreadyTaggedTruckData !== null && (
                          <Card
                            style={{
                              position: 'absolute',
                              top: '10px',
                              left: '10px',
                              backgroundColor: boxiPrimary,
                              display: 'flex',
                              justifyContent: 'space-between',
                              color: '#fff',
                              alignItems: 'baseline',
                              cursor: 'pointer'
                            }}
                            onClick={() => {
                              let selected = truckList.find(item => item.truck_id === alreadyTaggedTruckData.truck_id && alreadyTaggedTruckData.license_plate === item.license_plate)
                              setShowTagInput(true)
                              setEditTag(true)
                              setSelectedValue(selected)
                              if (vendor_id === -1) {
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                            }}
                          >
                            <CardContent style={{ fontSize: '10px', fontFamily: 'Poppins' }}>

                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Tagged By: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.user_name}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Truck Name: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.truck_name}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3', fontWeight: 300 }}>
                                  <div style={{ fontWeight: 300 }}>License Plate: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.license_plate}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Campaign Name: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.campaign_name}</span>
                              </div>
                            </CardContent>
                          </Card>
                        )}
                        {vendor_id !== -1 && showTagInput && truckList?.length > 0 && (<Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                            Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <Autocomplete
                              onChange={(e, newValue) => {
                                setSelectedValue(newValue);
                              }}
                              id="merchant-autocomplete"
                              disableClearable
                              value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                              options={truckList}
                              getOptionLabel={(option) => option.title}
                              renderOption={(props, option) => {
                                return (
                                  <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                  >
                                    <CardActionArea>
                                      <CardHeader
                                        title={<div className={'text-truncate'} style={{
                                          maxWidth: 230, fontFamily: 'Poppins',
                                          fontSize: '12px'
                                        }}>
                                          {option.truck_name}
                                        </div>
                                        }
                                        subheader={<div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'start',
                                          fontFamily: 'Poppins',
                                          fontSize: '10px'

                                        }}>
                                          <div>
                                            {option.license_plate}
                                          </div>
                                          <div>
                                            {option.campaign_display_name}
                                          </div>
                                        </div>}
                                        action={
                                          <PaidRoundedIcon
                                            style={{
                                              color: boxiPrimary,
                                            }}
                                          />
                                        }
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              }}
                              renderInput={(params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <TextField
                                    {...params}
                                    label="Tag Image to truck"
                                    variant="standard"
                                    onChange={(e) => debouncedHandler(e.target.value)}
                                  />
                                  {selectedValue?.title !== '' && !saveTagLoading ? (
                                    <SaveIcon
                                      color="primary"
                                      onClick={() => saveTagHandler(images[currentImage])}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  ) : selectedValue?.title !== '' && saveTagLoading ? (
                                    <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                  ) : (
                                    <SaveIcon
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}
                                </div>
                              )}
                            />
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>)}
                        {vendor_id === -1 && selectedVendorId && showTagInput && truckList?.length > 0 && (<Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                          Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <Autocomplete
                              onChange={(e, newValue) => {
                                setSelectedValue(newValue);
                              }}
                              id="merchant-autocomplete"
                              disableClearable
                              value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                              options={truckList}
                              getOptionLabel={(option) => option.title}
                              renderOption={(props, option) => {
                                return (
                                  <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                  >
                                    <CardActionArea>
                                      <CardHeader
                                        title={<div className={'text-truncate'} style={{
                                          maxWidth: 230, fontFamily: 'Poppins',
                                          fontSize: '12px'
                                        }}>
                                          {option.truck_name}
                                        </div>
                                        }
                                        subheader={<div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'start',
                                          fontFamily: 'Poppins',
                                          fontSize: '10px'

                                        }}>
                                          <div>
                                            {option.license_plate}
                                          </div>
                                          <div>
                                            {option.campaign_display_name}
                                          </div>
                                        </div>}
                                        action={
                                          <PaidRoundedIcon
                                            style={{
                                              color: boxiPrimary,
                                            }}
                                          />
                                        }
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              }}
                              renderInput={(params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <TextField
                                    {...params}
                                    label="Tag Image to truck"
                                    variant="standard"
                                    onChange={(e) => debouncedHandler(e.target.value)}
                                  />
                                  {selectedValue?.title !== '' && !saveTagLoading ? (
                                    <SaveIcon
                                      color="primary"
                                      onClick={() => saveTagHandler(images[currentImage])}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  ) : selectedValue?.title !== '' && saveTagLoading ? (
                                    <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                  ) : (
                                    <SaveIcon
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}
                                </div>
                              )}
                            />
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>)}
                        {showTagInput && (truckList.length === 0) && vendor_id !== -1 && !loadingCampaigns && (
                          <Modal isOpen={true} className='composeModal'>
                            <ModalHeader>
                            Select Truck To Tag
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ margin: '20px' }}>
                                No Truck Found to Tag
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>

                          </Modal>

                        )}
                        {showTagInput && (truckList.length === 0) && vendor_id === -1 && selectedVendorId && !loadingCampaigns && (
                          <Modal isOpen={true} className='composeModal'>
                            <ModalHeader>
                            Select Truck To Tag
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ margin: '20px' }}>
                                No Truck Found to Tag
                              </div>

                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>

                          </Modal>

                        )}
                        {showTagInput && vendor_id === -1 && truckList.length === 0 && !selectedVendorId && (
                          <Modal isOpen={true} className='composeModal'>
                            <ModalHeader>
                              Select Vendor
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', columnGap: 10 }}>
                                <TextField
                                  id="standard-search"
                                  label="Search Vendor"

                                  style={{
                                    borderRadius: '10px'
                                  }}
                                  variant="outlined"
                                  value={searchVendor}
                                  onChange={(e) => setSearchVendor(e.target.value)}
                                />
                                <Button style={{
                                  borderRadius: '10px',
                                  border: '1px solid' + boxiPrimary
                                }} disabled={isVendorSearchLoading} color="primary" onClick={searchVendors}>Search</Button>
                              </div>
                              {vendors.length > 0 && <div className={classes.searchVendorList}>
                                {vendors.map((vendor, index) => {
                                  return (
                                    <div className={classes.searchVendor} style={{ cursor: 'pointer', filter: `'contrast(1)` }} onClick={() => {
                                      onSearchVendorClickHandler(vendor)
                                    }}>
                                      <div className={classes.vendorName}>{vendor.name}</div>
                                      <div className={classes.vendorPhone}>{vendor.phone_num}</div>
                                    </div>
                                  )
                                })}
                              </div>}
                              {isVendorSearchLoading && vendors.length === 0 && (
                                <div style={{ margin: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <Spinner style={{ color: boxiPrimary, margin: '0px 10px' }}></Spinner>
                                  <div>Loading Vendors...</div>
                                </div>
                              )}

                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>
                        )}
                      </FullScreenModal>
                    }
                  </>
                  :
                  <div>
                    <Image height="100%" src={typeof message.media === 'string' ? message.media : message.media.url} alt="message" onClick={() => setFullScreen(true)} />
                    {fullScreen &&
                      <FullScreenModal>
                        <HighlightOffIcon onClick={closeFullScreen} style={{ position: 'absolute', top: 15, right: 15, cursor: 'pointer', color: 'white' }} />
                        <div style={{ color: 'white' }}>
                          {isImageDownloading ?
                            <Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: 'white' }}></Spinner>
                            :
                            <>
                              <DownloadIcon onClick={() => handleDownload(typeof message.media === 'string' ? message.media : message.media.url)} style={{ position: 'absolute', top: 16, right: 50, cursor: 'pointer' }} />
                              {message?.direction === 'inbound' && isCurrentChatPictureBlast && !isTaggingDisable && <LocalOfferIcon onClick={() => setShowTagInput(true)} style={{ position: 'absolute', top: 16, right: 80, cursor: 'pointer' }} />}
                              {isTagLoading && isCurrentChatPictureBlast && (<Spinner style={{ position: 'absolute', height: 20, width: 20, top: 16, right: 80, cursor: 'not-allowed', color: 'white' }}></Spinner>)}

                            </>
                          }
                        </div>
                        <Image height="100vh" width="auto" src={typeof message.media === 'string' ? message.media : message.media.url} alt="message" />
                        {isCurrentChatPictureBlast && isTaggingDisable && alreadyTaggedTruckData !== null && (
                          <Card
                            style={{
                              position: 'absolute',
                              top: '10px',
                              left: '10px',
                              backgroundColor: boxiPrimary,
                              display: 'flex',
                              justifyContent: 'space-between',
                              color: '#ffff',
                              alignItems: 'baseline',
                              cursor: 'pointer'
                            }}
                            onClick={() => {
                              let selected = truckList.find(item => item.truck_id === alreadyTaggedTruckData.truck_id && alreadyTaggedTruckData.license_plate === item.license_plate)
                              setShowTagInput(true)
                              setEditTag(true)
                              setSelectedValue(selected)
                              if (vendor_id === -1) {
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                            }}
                          >
                            <CardContent style={{ fontSize: '10px', fontFamily: 'Poppins' }}>

                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Tagged By: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.user_name}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Truck Name: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.truck_name}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3', fontWeight: 300 }}>
                                  <div style={{ fontWeight: 300 }}>License Plate: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.license_plate}</span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', columnGap: 6 }}>
                                <span style={{ color: '#D3D3D3' }}>
                                  <div style={{ fontWeight: 300 }}>Campaign Name: </div>
                                </span>
                                <span style={{ fontWeight: '400', fontSize: 12 }}>{alreadyTaggedTruckData?.campaign_name}</span>
                              </div>
                            </CardContent>
                          </Card>
                        )}
                        {vendor_id !== -1 && showTagInput && truckList?.length > 0 && (<Modal isOpen={true} className='composeModal'>
                          <ModalHeader>
                          Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <Autocomplete
                              onChange={(e, newValue) => {
                                setSelectedValue(newValue);
                              }}
                              id="merchant-autocomplete"
                              disableClearable
                              value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                              options={truckList}
                              getOptionLabel={(option) => option.title}
                              renderOption={(props, option) => {
                                return (
                                  <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                  >
                                    <CardActionArea>
                                      <CardHeader
                                        title={<div className={'text-truncate'} style={{
                                          maxWidth: 230, fontFamily: 'Poppins',
                                          fontSize: '12px'
                                        }}>
                                          {option.truck_name}
                                        </div>
                                        }
                                        subheader={<div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'start',
                                          fontFamily: 'Poppins',
                                          fontSize: '10px'

                                        }}>
                                          <div>
                                            {option.license_plate}
                                          </div>
                                          <div>
                                            {option.campaign_display_name}
                                          </div>
                                        </div>}
                                        action={
                                          <PaidRoundedIcon
                                            style={{
                                              color: boxiPrimary,
                                            }}
                                          />
                                        }
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              }}
                              renderInput={(params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <TextField
                                    {...params}
                                    label="Tag Image to truck"
                                    variant="standard"
                                    sx={{ fontSize: 14 }}
                                    onChange={(e) => debouncedHandler(e.target.value)}
                                  />
                                  {selectedValue?.title !== '' && !saveTagLoading ? (
                                    <SaveIcon
                                      color="primary"
                                      onClick={() => saveTagHandler(images[currentImage])}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  ) : selectedValue?.title !== '' && saveTagLoading ? (
                                    <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                  ) : (
                                    <SaveIcon
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}

                                </div>
                              )}
                            />

                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>)}
                        {vendor_id === -1 && selectedVendorId && showTagInput && truckList?.length > 0 && (<Modal isOpen={true} className='composeModal' >
                          <ModalHeader>
                          Select Truck To Tag
                          </ModalHeader>
                          <ModalBody>
                            <Autocomplete
                              onChange={(e, newValue) => {
                                setSelectedValue(newValue);
                              }}
                              id="merchant-autocomplete"
                              disableClearable
                              value={alreadyTaggedTruck ? alreadyTaggedTruckData : selectedValue}
                              options={truckList}
                              getOptionLabel={(option) => option.title}
                              renderOption={(props, option) => {
                                return (
                                  <Card variant="outlined" style={{ cursor: 'pointer', padding: '0', margin: '0' }} {...props}
                                  >
                                    <CardActionArea>
                                      <CardHeader
                                        title={<div className={'text-truncate'} style={{
                                          maxWidth: 230, fontFamily: 'Poppins',
                                          fontSize: '12px'
                                        }}>
                                          {option.truck_name}
                                        </div>
                                        }
                                        subheader={<div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          justifyContent: 'center',
                                          alignItems: 'start',
                                          fontFamily: 'Poppins',
                                          fontSize: '10px'

                                        }}>
                                          <div>
                                            {option.license_plate}
                                          </div>
                                          <div>
                                            {option.campaign_display_name}
                                          </div>
                                        </div>}
                                        action={
                                          <PaidRoundedIcon
                                            style={{
                                              color: boxiPrimary,
                                            }}
                                          />
                                        }
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              }}
                              renderInput={(params) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <TextField
                                    {...params}
                                    label="Tag Image to truck"
                                    variant="standard"
                                    onChange={(e) => debouncedHandler(e.target.value)}
                                  />
                                  {selectedValue?.title !== '' && !saveTagLoading ? (
                                    <SaveIcon
                                      color="primary"
                                      onClick={() => saveTagHandler(images[currentImage])}
                                      style={{ cursor: 'pointer' }}
                                    />
                                  ) : selectedValue?.title !== '' && saveTagLoading ? (
                                    <Spinner style={{ height: 20, width: 20, top: 16, right: 50, cursor: 'not-allowed', color: boxiPrimary }}></Spinner>
                                  ) : (
                                    <SaveIcon
                                      style={{ cursor: 'pointer' }}
                                    />
                                  )}

                                </div>
                              )}
                            />
                          </ModalBody>
                          <ModalFooter>
                            <Button color="secondary" onClick={() => {
                              setShowTagInput(false)
                              setSearchVendor('');
                              setIsVendorSearchLoading(false);
                              setVendors([]);
                              setSelectedVendorId(null);
                              setSelectedVendor(null);
                              if (vendor_id === -1) {
                                setTruckList([])
                                setOriginalTruckList([]);
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                              }
                              setSelectedValue({ title: '', value: 0, truck_name: '' })

                            }}>
                              Close
                            </Button>
                          </ModalFooter>
                        </Modal>)}
                        {showTagInput && (truckList.length === 0) && vendor_id !== -1 && !loadingCampaigns && (
                          <Modal isOpen={true} className='composeModal'>
                            <ModalHeader>
                            Select Truck To Tag
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ margin: '20px' }}>
                                No Truck Found to Tag
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>

                        )}
                        {showTagInput && (truckList.length === 0) && vendor_id === -1 && selectedVendorId && !loadingCampaigns && (
                          <Modal isOpen={true} className='composeModal' >

                            <ModalHeader>
                            Select Truck To Tag
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ margin: '20px' }}>
                                No Truck Found to Tag
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>

                        )}
                        {showTagInput && vendor_id === -1 && truckList.length === 0 && !selectedVendorId && (
                          <Modal isOpen={true} className='composeModal'>
                            <ModalHeader>
                              Search Vendor
                            </ModalHeader>
                            <ModalBody>
                              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', columnGap: 10 }}>
                                <TextField
                                  id="standard-search"
                                  label="Search Vendor"

                                  variant="outlined"
                                  style={{
                                    borderRadius: '10px'
                                  }}
                                  value={searchVendor}
                                  onChange={(e) => setSearchVendor(e.target.value)}
                                />
                                <Button style={{
                                  borderRadius: '10px',
                                  border: '1px solid' + boxiPrimary
                                }} disabled={isVendorSearchLoading} color="primary" onClick={searchVendors}>Search</Button>
                                <CloseIcon
                                  onClick={() => {
                                    setShowTagInput(false)
                                    setSearchVendor('');
                                    setIsVendorSearchLoading(false);
                                    setVendors([]);
                                    setSelectedVendorId(null);
                                    setSelectedVendor(null);
                                    if (vendor_id === -1) {
                                      setTruckList([])
                                      setOriginalTruckList([]);
                                    }
                                  }}
                                  style={{ cursor: 'pointer' }}
                                />
                              </div>
                              {vendors.length > 0 && <div className={classes.searchVendorList}>
                                {vendors.map((vendor, index) => {
                                  return (
                                    <div className={classes.searchVendor} style={{ cursor: 'pointer', filter: `'contrast(1)` }} onClick={() => {
                                      onSearchVendorClickHandler(vendor)
                                    }}>
                                      <div className={classes.vendorName}>{vendor.name}</div>
                                      <div className={classes.vendorPhone}>{vendor.phone_num}</div>
                                    </div>
                                  )
                                })}
                              </div>}
                              {isVendorSearchLoading && vendors.length === 0 && (
                                <div style={{ margin: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                  <Spinner style={{ color: boxiPrimary, margin: '0px 10px' }}></Spinner>
                                  <div>Loading Vendors...</div>
                                </div>
                              )}

                            </ModalBody>
                            <ModalFooter>
                              <Button color="secondary" onClick={() => {
                                setShowTagInput(false)
                                setSearchVendor('');
                                setIsVendorSearchLoading(false);
                                setVendors([]);
                                setSelectedVendorId(null);
                                setSelectedVendor(null);
                                if (vendor_id === -1) {
                                  setTruckList([])
                                  setOriginalTruckList([]);
                                  setSearchVendor('');
                                  setIsVendorSearchLoading(false);
                                  setVendors([]);
                                  setSelectedVendorId(null);
                                  setSelectedVendor(null);
                                }
                                setSelectedValue({ title: '', value: 0, truck_name: '' })

                              }}>
                                Close
                              </Button>
                            </ModalFooter>
                          </Modal>
                        )}
                      </FullScreenModal>
                    }
                  </div>
            )
          }
        </div>
        <div style={{ marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: message.body.replace(/\n/g, '<br>') }}></div>
        <div className={message.message_status == 'scheduled' ? classes.scheduledTime : classes.time}>
          <span>{message.message_status == 'scheduled' && 'Created At: '} {moment.tz(message.created_at, 'America/Los_Angeles').format('MM/DD hh:mm A')}</span>
          {message.message_status == 'scheduled' && <span>Scheduled For: {moment.tz(message.scheduled_for, 'America/Los_Angeles').format('MM/DD hh:mm A')}</span>}
        </div>
        {message.direction == 'outbound' && <div className={classes.senderName}>{message.sender_name}</div>}
      </div>
      {message.direction == 'outbound' &&
        <>
          {(message.message_status == 'undelivered' || message.message_status == 'failed') && <Tooltip title={`Message ${message.message_status == 'undelivered' ? 'was not delivered' : message.message_status}`}><span><ErrorIcon sx={{ height: 16, color: boxiRed }} /></span></Tooltip>}
          {message.message_status == 'sent' && <span><DoneIcon sx={{ height: 16, color: '#7d7d7d' }} /></span>}
          {message.message_status == 'delivered' && <span><DoneAllIcon sx={{ height: 16, color: '#1a1a1a' }} /></span>}
        </>
      }
    </div>
  );
}
export default Message;
